// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__91_ZF","left":"styles_left__U2mSq","desktopActions":"styles_desktopActions__3tpnY","title":"styles_title__xagQD"};